// 解析 TNode 数据结构
export default function parseTNode(renderNode, renderParams, defaultNode) {
  var node = null;
  if (typeof renderNode === "function") {
    node = renderNode(renderParams);
  } else if (renderNode === true) {
    node = defaultNode;
  } else if (renderNode !== null) {
    node = renderNode !== null && renderNode !== void 0 ? renderNode : defaultNode;
  }
  return node;
}